<template>
  <div>
    <el-dialog class="msgDio" :visible.sync="open" width="5rem" center>
      <div> <b>Transaction failed！</b> </div>
      <div>Transaction Block Number : <el-button type="text">{{blockNumber}}</el-button></div>
      <div>You can enter the <el-button type="text" @click="topath">block browser</el-button>  to query transaction details</div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      blockNumber:undefined,
      open: false,
    };
  },
  mounted() {
  },
  methods: {
    show(val){
      this.blockNumber = val
      this.open = true
    },
    topath(){
      window.open(process.env.VUE_APP_ERROR_ADDRESS,"_blank")
    },
  },
};
</script>
<style scoped lang="scss">
.msgDio {

  /deep/ .el-dialog__header {
    border-bottom: 0;
  }

  div {
    text-align: center;
    line-height: 30px;
  }
}

</style>
